export default {
  name: 'Lead redirect',
  path: '/lead-redirect',
  component: () => import('./create-lead-redirect.vue')
};
